// const baseURL = "http://127.0.0.1:8000/api/rto/"

const baseURL = "https://priyanshi.coalfeed.in/api/rto/"

// const baseURL = "http://192.168.31.78:8000/api/rto/"
const config = {

    apiBaseURL : `${baseURL}`,
    staticBaseURL : `${baseURL}`,
    apiTimeout: 500000
}
export default config;